// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".linkify_de2f a {\n  text-decoration: underline;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/Linkify.scss","Linkify.scss"],"names":[],"mappings":"AACI;EACI,0BAAA;ACAR","file":"Linkify.scss","sourcesContent":[".linkify {\n    a {\n        text-decoration: underline;\n    }\n}\n",".linkify a {\n  text-decoration: underline;\n}"]}]);
// Exports
exports.locals = {
	"linkify": "linkify_de2f"
};
module.exports = exports;
